import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaChevronDown, FaChevronUp, FaUsers, FaIndustry, FaTrophy, FaLeaf, FaHandshake, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import AboutSection from '../components/AboutSection';
import ClientSlider from '../components/ClientSlider';
import Breadcrumbs from '../components/Breadcrumbs';
import bannerMain from '../assets/images/about/banner-main.jpg';
import { API_BASE_URL, UPLOADS_BASE_URL } from '../config';

// Import client images
import client1 from '../assets/images/clients/1.png';
import client2 from '../assets/images/clients/2.png';
import client3 from '../assets/images/clients/3.png';
import client4 from '../assets/images/clients/4.png';
import client5 from '../assets/images/clients/5.png';
import client6 from '../assets/images/clients/6.jpg';

const AboutPage = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  // Fetch team members from API
  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_BASE_URL}team-members.php`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch team members');
        }
        
        const data = await response.json();
        
        if (data.success && Array.isArray(data.team_members)) {
          setTeamMembers(data.team_members);
        } else if (Array.isArray(data)) {
          setTeamMembers(data);
        } else {
          console.error('Invalid team members data format:', data);
          setTeamMembers([]);
        }
      } catch (error) {
        console.error('Error fetching team members:', error);
        // Fallback to dummy data if API fails
        setTeamMembers([
          {
            id: 1,
            name: "Eleanor Pena",
            position: "CEO & Co-founder",
            image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face",
            facebook_url: "#",
            instagram_url: "#",
            linkedin_url: "#"
          },
          {
            id: 2,
            name: "Leslie Alexander",
            position: "Product Manager",
            image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300&h=300&fit=crop&crop=face",
            facebook_url: "#",
            instagram_url: "#",
            linkedin_url: "#"
          },
          {
            id: 3,
            name: "Jane Cooper",
            position: "Web Developer",
            image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=300&h=300&fit=crop&crop=face",
            facebook_url: "#",
            instagram_url: "#",
            linkedin_url: "#"
          },
          {
            id: 4,
            name: "Floyd Miles",
            position: "Marketing Expert",
            image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=300&fit=crop&crop=face",
            facebook_url: "#",
            instagram_url: "#",
            linkedin_url: "#"
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);

  const accordionData = [
    {
      id: 1,
      icon: <FaUsers />,
      title: "Custom Made Office Furniture",
      content: "Every piece—from executive desks and reception counters to modular workstations and storage units—is crafted in-house from high-quality materials like engineered wood, HPL, veneer, steel, and acoustic panels "
    },
    {
      id: 2,
      icon: <FaUsers />,
      title: "Design & Space Planning",
      content: "Our in-house design team creates smart layouts and 3D visualizations to ensure efficient, stylish workspaces tailored to your budget and space constraints."
    },
    {
      id: 3,
      icon: <FaUsers />,
      title: "Manufacturing & Assembly",
      content: "Located in Al Quoz Industrial Area 1, our UAE factory ensures rigorous quality control and fast production—typically completing mid-size orders within 5 working days after design approval."
    },
    {
      id: 4,
      icon: <FaUsers />,
      title: "Delivery & Installation",
      content: "We provide free delivery and installation across Dubai, Abu Dhabi, Sharjah, Ajman, Fujairah, and strategic parts of the GCC."
    }
   
  ];

  // Breadcrumbs configuration
  const breadcrumbsLinks = [
    { text: 'Home', url: '/' },
    { text: 'About Us', url: '/about' }
  ];

  return (
    <div className="about-page">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>About Us - Design Craft | Premium Office Furniture Manufacturer in UAE</title>
        <meta 
          name="description" 
          content="Learn about Design Craft, a leading office furniture manufacturer in UAE. We specialize in custom-made office furniture, design & space planning, manufacturing & assembly, and delivery & installation across Dubai, Abu Dhabi, Sharjah, and GCC." 
        />
        <meta 
          name="keywords" 
          content="about design craft, office furniture manufacturer UAE, custom office furniture Dubai, office space planning, furniture manufacturing Al Quoz, office fitout company UAE, executive desks Dubai, office chairs Abu Dhabi, storage solutions Sharjah" 
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Design Craft" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="About Us - Design Craft | Premium Office Furniture Manufacturer" />
        <meta 
          property="og:description" 
          content="Discover Design Craft's story - from custom office furniture manufacturing to complete office fitouts. Serving 500+ satisfied clients across UAE and GCC with 150+ skilled team members." 
        />
        
      </Helmet>

      {/* Breadcrumbs */}
      <Breadcrumbs title="About Us" links={breadcrumbsLinks} />
      
      {/* Hero About Section */}
      <AboutSection hideKnowMore={true} />
     

      {/* Simple Banner Section */} 
      <div className='simple-banner-section'>
        <div className='simple-banner-container'>
          {/* <div className="section-header">
            <h2 className="section-title">Our Team Members</h2>
            <p className="section-subtitle">
            Our supportive team members are dedicated, passionate, and always ready to help. They work together to ensure every client receives the best service and a seamless, friendly experience.
            </p>
          </div> */}
          
          {/* <div className="banner-image-simple">
            <img 
              src={bannerMain} 
              alt="Design Craft Production Facility"
              loading="lazy"
            />
          </div> */}

          {/* Team Members Cards */}
          {/* <div className="team-members-section">
            <div className="team-members-grid">
              
              {loading ? (
                <p>Loading team members...</p>
              ) : teamMembers.length === 0 ? (
                <p>No team members data available.</p>
              ) : (
                teamMembers.map((member) => (
                  <div key={member.id} className="team-member-card">
                    <div className="member-image">
                      <img 
                        src={member.image?.startsWith('http') ? member.image : `${UPLOADS_BASE_URL}team/${member.image}`} 
                        alt={member.name}
                        onError={(e) => {
                          e.target.src = 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face';
                        }}
                        loading="lazy"
                      />
                    </div>
                    <div className="member-info">
                      <h3 className="member-name">{member.name}</h3>
                      <p className="member-position">{member.position}</p>
                      <div className="member-social">
                        <a href={member.facebook_url || '#'} target="_blank" rel="noopener noreferrer" className="social-link"><FaFacebookF /></a>
                        <a href={member.instagram_url || '#'} target="_blank" rel="noopener noreferrer" className="social-link"><FaInstagram /></a>
                        <a href={member.linkedin_url || '#'} target="_blank" rel="noopener noreferrer" className="social-link"><FaLinkedinIn /></a>
                      </div>
                    </div>
                  </div>
                ))
              )}

            </div>
          </div> */}
          
        </div>
      </div>

      {/* Accordion Section */}
      <div className="accordion-section">
        <div className="accordion-container">
        <div className="section-header">
            <h2 className="section-title">What We Do</h2>
           
          </div>

          <div className="accordion-wrapper">
            {accordionData.map((item, index) => (
              <div 
                key={item.id} 
                className={`accordion-item ${activeAccordion === index ? 'active' : ''}`}
              >
                <div 
                  className="accordion-header"
                  onClick={() => toggleAccordion(index)}
                >
                  <div className="accordion-title-wrapper">
                    <div className="accordion-icon">
                      {item.icon}
                    </div>
                    <h3 className="accordion-title">{item.title}</h3>
                  </div>
                  <div className="accordion-toggle">
                    {activeAccordion === index ? <FaChevronUp /> : <FaChevronDown />}
                  </div>
                </div>
                
                <div className={`accordion-content ${activeAccordion === index ? 'open' : ''}`}>
                  <div className="accordion-text">
                    <p>{item.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Our Clients Section */}
      <ClientSlider/>

      {/* Mission and Reach Section */}
      <div className="mission-reach-section">
        <div className="mission-reach-container">
          <div className="mission-reach-grid">
            
            {/* Our Mission */}
            <div className="mission-card">
              <div className="card-header">
                <div className="card-icon mission-icon">
                  🎯
                </div>
                <h3 className="card-title">Our Mission</h3>
              </div>
              <div className="card-content">
                <p>
                  To empower organizations with furniture solutions that reflect their brand identity, 
                  enhance productivity, and foster well being—delivered through precision manufacturing, 
                  forward thinking design, and seamless service.
                </p>
              </div>
            </div>

            {/* Our Reach */}
            <div className="reach-card">
              <div className="card-header">
                <div className="card-icon reach-icon">
                  🌍
                </div>
                <h3 className="card-title">Our Reach</h3>
              </div>
              <div className="card-content">
                <p>
                  We've successfully furnished startups, SMEs, and corporate offices across key business hubs: 
                  Dubai, Abu Dhabi, Sharjah, Ajman, Fujairah, and parts of the GCC region. With over 150 skilled 
                  team members and hundreds of satisfied clients, we pride ourselves on delivering beyond expectations.
                </p>
                <div className="reach-stats">
                  <div className="stat-item">
                    <span className="stat-number">150+</span>
                    <span className="stat-label">Team Members</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">500+</span>
                    <span className="stat-label">Satisfied Clients</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">6</span>
                    <span className="stat-label">Emirates Covered</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <style jsx>{`
        .about-page {
          min-height: 100vh;
        }

        /* Simple Banner Section */
        .simple-banner-section {
          padding: 40px 0;
          background: #ffffff;
        }

        .simple-banner-container {
          max-width: 90%;
          margin: 0 auto;
          padding: 0 20px;
        }

        .section-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .section-title {
            text-transform: CAPITALIZE;
          font-size: 4rem;
          font-weight: 600;
          margin:0;
          color: #2c3e50;
          margin-bottom: 15px;
          font-family: var(--font-primary);
        }

        .section-subtitle {
          font-size: 1.1rem;
          color: #6c757d;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .banner-image-simple {
          width: 100%;
          border-radius: 10px;
          overflow: hidden;
          // box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        }

        .banner-image-simple img {
          width: 100%;
          height: auto;
          display: block;
        }

        /* Accordion Section */
        .accordion-section {
          padding: 30px 0;
          // background: #f8f9fa;
        }

        .accordion-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .accordion-wrapper {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .accordion-item {
          background: #ffffff;
          border: 2px solid #f1f3f4;
          border-radius: 15px;
          overflow: hidden;
          transition: all 0.3s ease;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .accordion-item:hover {
          border-color: #fe781d;
          box-shadow: 0 4px 20px rgba(0, 123, 255, 0.1);
        }

        .accordion-item.active {
          border-color: #fe781d;
          box-shadow: 0 4px 20px rgba(0, 123, 255, 0.15);
        }

        .accordion-header {
          padding: 25px 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          background: #ffffff;
          transition: background 0.3s ease;
        }

        .accordion-header:hover {
          background: #f8f9fa;
        }

        .accordion-item.active .accordion-header {
          background: #f8f9fa;
        }

        .accordion-title-wrapper {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .accordion-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          background: #fe781d;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.2rem;
        }

        .accordion-title {
          font-size: 1.3rem;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
        }

        .accordion-toggle {
          font-size: 1.2rem;
          color: #fe781d;
          transition: transform 0.3s ease;
        }

        .accordion-item.active .accordion-toggle {
          transform: rotate(180deg);
        }

        .accordion-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .accordion-content.open {
          max-height: 200px;
        }

        .accordion-text {
          padding: 0 30px 30px 100px;
        }

        .accordion-text p {
          font-size: 1rem;
          line-height: 1.7;
          color: #555;
          margin: 0;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .section-title {
            font-size: 2rem;
          }

          .section-subtitle {
            font-size: 1rem;
          }

          .accordion-text {
            padding: 0 20px 25px 20px;
          }

          .accordion-title-wrapper {
            gap: 15px;
          }

          .accordion-icon {
            width: 40px;
            height: 40px;
            font-size: 1rem;
          }

          .accordion-title {
            font-size: 1.1rem;
          }
        }

        @media (max-width: 480px) {
          .simple-banner-section {
            padding: 40px 0;
          }
          .simple-banner-container {
    max-width: 100%;
    margin: 0 auto;
    padding: 0;
}

.team-members-section {
    padding: 30px 0 10px 0;
    background: #ffffff;
}
          .accordion-section {
            padding: 40px 0;
          }

          .section-title {
            font-size: 1.8rem;
          }

          .accordion-header {
            padding: 20px;
          }
        }

        /* Mission and Reach Section */
        .mission-reach-section {
          padding: 80px 0;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        }

        .mission-reach-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .mission-reach-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
          align-items: start;
        }

        .mission-card,
        .reach-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 40px 35px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          border: 1px solid #f1f3f4;
        }

        .mission-card:hover,
        .reach-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
          border-color: #fe781d;
        }

        .card-header {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 25px;
        }

        .card-icon {
          width: 70px;
          height: 70px;
          border-radius: 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          font-weight: bold;
          color: white;
          position: relative;
          overflow: hidden;
        }

        .mission-icon {
          background: linear-gradient(135deg, #fe781d, #ff9500);
        }

        .reach-icon {
          background: linear-gradient(135deg, #28a745, #20c997);
        }

        .card-icon::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 100%);
        }

        .card-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: #2c3e50;
          margin: 0;
          font-family: var(--font-primary);
        }

        .card-content p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #555;
          margin: 0 0 25px 0;
          text-align: justify;
        }

        .reach-stats {
          display: flex;
          gap: 30px;
          justify-content: space-between;
          margin-top: 30px;
          padding-top: 25px;
          border-top: 2px solid #f1f3f4;
        }

        .stat-item {
          text-align: center;
          flex: 1;
        }

        .stat-number {
          display: block;
          font-size: 2rem;
          font-weight: 800;
          color: #fe781d;
          margin-bottom: 5px;
          font-family: var(--font-primary);
        }

        .stat-label {
          font-size: 0.9rem;
          color: #6c757d;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* Responsive for Mission & Reach */
        @media (max-width: 768px) {
          .mission-reach-section {
            padding: 60px 0;
          }

          .mission-reach-grid {
            grid-template-columns: 1fr;
            gap: 30px;
          }

          .mission-card,
          .reach-card {
            padding: 30px 25px;
          }

          .card-header {
            gap: 15px;
            margin-bottom: 20px;
          }

          .card-icon {
            width: 60px;
            height: 60px;
            font-size: 1.5rem;
          }

          .card-title {
            font-size: 1.5rem;
          }

          .card-content p {
            font-size: 1rem;
          }

          .reach-stats {
            gap: 20px;
            margin-top: 20px;
            padding-top: 20px;
          }

          .stat-number {
            font-size: 1.6rem;
          }

          .stat-label {
            font-size: 0.8rem;
          }
        }

        @media (max-width: 480px) {
          .mission-reach-section {
            padding: 50px 0;
          }

          .mission-card,
          .reach-card {
            padding: 25px 20px;
          }

          .card-header {
            flex-direction: column;
            text-align: center;
            gap: 15px;
          }

          .card-icon {
            width: 50px;
            height: 50px;
            font-size: 1.3rem;
          }

          .card-title {
            font-size: 1.3rem;
          }

          .reach-stats {
            flex-direction: column;
            gap: 15px;
          }

          .stat-item {
            padding: 10px;
            background: #f8f9fa;
            border-radius: 10px;
          }
        }

        /* Team Members Section */
        .team-members-section {
          padding: 60px 0 40px 0;
          background: #ffffff;
        }

        .team-members-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .team-member-card {
          background: #f8f9fa;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          transition: all 0.3s ease;
          position: relative;
        }

        .team-member-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
        }

        .member-image {
          width: 100%;
          height: 280px;
          overflow: hidden;
          border-radius: 20px 20px 0 0;
          position: relative;
        }

        .member-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .team-member-card:hover .member-image img {
          transform: scale(1.1);
        }

        .member-info {
          padding: 25px 20px;
          width: 100%;
          background: #f8f9fa;
        }

        .member-name {
          font-size: 1.4rem;
          font-weight: 700;
          color: #2c3e50;
          margin-bottom: 8px;
          font-family: var(--font-primary);
        }

        .member-position {
          font-size: 1rem;
          color: #6c757d;
          margin-bottom: 20px;
          font-weight: 500;
        }

        .member-social {
          display: flex;
          justify-content: center;
          gap: 15px;
        }

        .social-link {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #ffffff;
          color: #6c757d;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          font-size: 1.1rem;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .social-link:hover {
          color: #ffffff;
          background: #fe781d;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(254, 120, 29, 0.3);
        }

        /* Responsive for Team Members */
        @media (max-width: 1024px) {
          .team-members-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 25px;
          }
        }

        @media (max-width: 768px) {
          .team-members-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .team-member-card {
            margin-bottom: 20px;
          }

          .member-image {
            height: 250px;
          }

          .member-name {
            font-size: 1.2rem;
          }

          .member-position {
            font-size: 0.9rem;
          }

          .social-link {
            width: 35px;
            height: 35px;
            font-size: 0.9rem;
          }
        }

        @media (max-width: 480px) {
          .team-members-grid {
            grid-template-columns: 1fr;
            padding: 0 15px;
          }
  .simple-banner-container {
    max-width: 100%;
    margin: 0 auto;
    padding: 0;
}

.team-members-section {
    padding: 30px 0 10px 0;
    background: #ffffff;
}
          .team-member-card {
            max-width: 300px;
            margin: 0 auto 20px auto;
          }

          .member-image {
            height: auto;
          }

          .member-name {
            font-size: 1.1rem;
          }

          .member-position {
            font-size: 0.85rem;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutPage; 